import {toTmsFormat} from "../../common/utils/TmsUtils";

const TRACK_ZONE = "lanceur_aida";
const TRACK_TARGET_EMBEDDED_LAUNCHER = "lanceur_integre";

enum AiChatbotTrackingName {
    IMPRESSION = "impression",
    LOADING_ERROR = "erreur_chargement",
    CHIP_CLICK = "lanceur_integre_clic_pastille",
    BUTTON_CLICK = "lanceur_integre_clic_bouton",
}

function track(name: AiChatbotTrackingName, target: string): void {
    try {
        Tms.link({track_zone: TRACK_ZONE, track_nom: name, track_cible: target});
    } catch (error) {
        console.warn("AI Chatbot : tracking impossible", error);
    }
}

export const AiChatbotTrackingService = {
    trackImpression(): void {
        track(AiChatbotTrackingName.IMPRESSION, TRACK_TARGET_EMBEDDED_LAUNCHER);
    },

    trackLoadingError(): void {
        track(AiChatbotTrackingName.LOADING_ERROR, TRACK_TARGET_EMBEDDED_LAUNCHER);
    },

    trackChipClick(label: string): void {
        track(AiChatbotTrackingName.CHIP_CLICK, toTmsFormat(label));
    },

    trackButtonClick(label: string): void {
        track(AiChatbotTrackingName.BUTTON_CLICK, toTmsFormat(label));
    },
};
